<template>
  <div>
    <!-- Table section -->
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" md="4" sm="12">
            <v-btn rounded class="mr-5" depressed color="primary" @click="handleAdd()">
              <v-icon class="mr-1"> mdi-plus-circle</v-icon>
              {{ $t("addNew") }}
            </v-btn>
          </v-col>

          <v-col cols="6" md="2" sm="6">
            <v-menu
                v-model="menuDateFrom"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="from_date"
                    :label="$t('dateFrom')"
                    prepend-inner-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                ></v-text-field>
              </template>
              <v-date-picker
                  :first-day-of-week="0"
                  v-model="from_date"
                  @input="menuDateFrom = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="6" md="2" sm="6">

            <v-menu
                v-model="menuDateTo"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="to_date"
                    :label="$t('dateTo')"
                    prepend-inner-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                ></v-text-field>
              </template>
              <v-date-picker
                  :first-day-of-week="0"
                  v-model="to_date"
                  @input="menuDateTo = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="6" md="2" sm="6">
            <v-text-field
                v-model="search"
                :label="$t('search')"
                single-line
                outlined
                dense
                clearable
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" md="2" sm="12">
            <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleSearch()">
              <v-icon class="mr-1"> mdi-magnify</v-icon>
            </v-btn>

            <v-btn @click="exportExcel('exportExcel')" outlined>
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172"
                   style=" fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                   stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                   font-family="none" font-weight="none" font-size="none" text-anchor="none"
                   style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="#000000">
                    <path
                        d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path>
                  </g>
                </g>
              </svg>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
          id="exportExcel"
          :loading="loading"
          :headers="headers"
          :items="listDraftInvoice"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
      >
        <!-- Header -->
        <template v-slot:progress class="text-center">
          <v-progress-circular indeterminate color="green" :value="50"></v-progress-circular>
        </template>
        <template v-slot:header.loading_date="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.unloading_date="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.reference="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.supplier_name="{ header }">
          {{ isMiller || isExporter || isOperator ? $t(header.text) : '' }}
        </template>
        <template v-slot:header.client_name="{ header }">{{ isOperator ? $t(header.text) : '' }}</template>
        <template v-slot:header.total_quantity="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.total_cost="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.total_sell="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.total_margin="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

        <!-- Body section -->
        <template v-slot:item.loading_date="{ item }">{{ item.loading_date | dateFormat }}</template>
        <template v-slot:item.unloading_date="{ item }">{{ item.accepted_date | dateFormat }}</template>
        <template v-slot:item.supplier_name="{ item }">
          {{ isMiller || isExporter || isOperator ? item.supplier_name : '' }}
        </template>
        <template v-slot:item.client_name="{ item }">{{ isOperator ? item.client_name : '' }}</template>
        <template v-slot:item.total_quantity="{ item }">{{ item.total_quantity }}</template>
        <template v-slot:item.total_cost="{ item }">{{ (item.total_cost ? item.total_cost : 0) | formatNumber }} </template>
        <template v-slot:item.total_sell="{ item }">{{ (item.total_sell ? item.total_sell : 0) | formatNumber }} </template>
        <template v-slot:item.total_margin="{ item }">{{ (item.total_margin ? item.total_margin : 0) | formatNumber }} </template>


        <!-- Action -->
        <template v-slot:item.action="{ item }">
          <v-btn @click="createFinalInvoice(item.id)" color="success" small rounded
                 class="table-action-button no-text-transform mr-2">{{ $t('printInvoice') }}
          </v-btn>
          <v-btn @click="handleEdit(item, $event)" :disabled="item.invoice_type !== 'draft'" color="primary" outlined
                 class="table-action-button mr-2" text icon>
            <font-awesome-icon icon="edit"/>
          </v-btn>
          <v-btn @click="handleRemove(item.id)" color="error"  outlined class="table-action-button mr-2" text icon>
            <font-awesome-icon icon="trash"/>
          </v-btn>
          <v-btn color="teal" outlined class="table-action-button" text icon
                 :to="{ name: 'beeshop.buyback.buyback-trading.invoice-draft-print', params: { id: item.id}}">
            <font-awesome-icon icon="print"/>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Pagination -->
      <div class="text-center pt-2">
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{
              totalPage
            }}
          </v-col>
          <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
            <v-select
                :label="$t('perPage')"
                v-model="itemsPerPage"
                :items="pageList"
            ></v-select>
          </v-col>

          <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
          ></v-pagination>

          <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
            <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
            ></v-text-field>
          </v-col>
        </v-card-actions>
      </div>
    </v-card>
    <!-- End Table section -->

    <!-- Form section -->
    <v-form v-model="valid" ref="formData" lazy-validation>
      <v-dialog v-model="dialog" persistent fullscreen>
        <v-overlay :value="overlay">
          <v-progress-circular
              indeterminate
              size="64"
          ></v-progress-circular>
        </v-overlay>

        <v-card>
          <v-card-title class="dialog-header">
            <span class="headline" v-if="toggleAdd">{{ $t("addInvoiceDraft") }}</span>
            <span class="headline" v-if="!toggleAdd">{{ $t("editInvoiceDraft") }}</span>
            <v-spacer></v-spacer>
            <v-btn fab text icon @click="handleClose()" v-shortkey="['esc']" @shortkey.native="handleClose()">
              <font-awesome-icon style="font-size: 20px;color: white" icon="times"/>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3" md="3" class="seperate-line-verticle">
                <v-row style="padding-right: 10px">

                  <v-col cols="12" sm="12" md="12" v-if="isOperator" style="padding-bottom: 0px; padding-top: 5px">
                    <v-autocomplete
                        v-model="formDoc.client_id"
                        :items="listMillerAndExporter"
                        outlined
                        dense
                        item-text="full_name"
                        item-value="contact_id"
                        :label="$t('client') + '*'"
                        :rules="selectRules"
                        required
                        :disabled="enabledUser"
                    >

                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" v-if="isMiller || isExporter || isOperator"
                         style="padding-bottom: 0px; padding-top: 5px">
                    <v-autocomplete
                        v-model="formDoc.supplier_id"
                        :items="listCropTrader"
                        outlined
                        dense
                        item-text="full_name"
                        item-value="crop_id"
                        :label="$t('supplier') + '*'"
                        :rules="selectRules"
                        required
                        :disabled="enabledUser"

                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                    <v-select
                        :items="currencyOptionList"
                        :label="$t('currency') + '*'"
                        outlined
                        v-model="formDoc.currency_code"
                        :rules="selectRules"
                        item-text="text"
                        item-value="id"
                        dense
                    >
                      <template v-slot:selection="{ item }">{{ item.text }}</template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                    <v-select
                        :items="invoiceType"
                        :label="$t('invoiceType') + '*'"
                        outlined
                        v-model="formDoc.invoice_type"
                        :rules="selectRules"
                        dense
                        item-value="id"
                    >
                      <template v-slot:selection="{ item }">{{ $t(item.id) }}</template>
                      <template v-slot:item="{ item }">{{ $t(item.id) }}</template>
                    </v-select>
                  </v-col>

                  <div cols="12" sm="12" md="12">
                    <fieldset style="border:1px solid #9e9e9e; border-radius: 4px; padding-top: 10px;">
                      <legend style="margin-left: 10px; color: gray">{{ $t('loadingLocation') }}</legend>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-autocomplete
                              v-model="formDoc.province_code"
                              :items="provinceOptionList"
                              auto-select-first
                              item-text="text"
                              item-value="id"
                              :label="$t('province')"
                              required
                              :rules="selectRules"
                              outlined
                              dense
                          >
                            <template v-slot:selection="{ item }">{{ item.text }}</template>
                            <template v-slot:item="{ item }">{{ item.text }}</template>
                          </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-autocomplete
                              v-model="formDoc.district_code"
                              :items="districtOptionList"
                              auto-select-first
                              item-text="text"
                              item-value="id"
                              :label="$t('district')"
                              required
                              outlined
                              :rules="selectRules"
                              dense
                          >
                            <template v-slot:selection="{ item }">{{ item.text }}</template>
                            <template v-slot:item="{ item }">{{ item.text }}</template>
                          </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-autocomplete
                              v-model="formDoc.commune_code"
                              :items="communeOptionList"
                              auto-select-first
                              item-text="text"
                              item-value="id"
                              :label="$t('commune')"
                              required
                              :rules="selectRules"
                              outlined
                              dense
                          >
                            <template v-slot:selection="{ item }">{{ item.text }}</template>
                            <template v-slot:item="{ item }">{{ item.text }}</template>
                          </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-menu
                              v-model="menuDate1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="formDoc.loading_date"
                                  :label="$t('loading_date')"
                                  prepend-inner-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                :first-day-of-week="0"
                                v-model="formDoc.loading_date"
                                @input="menuDate1 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-menu
                              v-model="menuDate2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="formDoc.unloading_date"
                                  :label="$t('unloading_date')"
                                  prepend-inner-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                :first-day-of-week="0"
                                v-model="formDoc.unloading_date"
                                @input="menuDate2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-text-field
                              outlined
                              dense
                              v-model="formDoc.druck_plate_no"
                              :label="$t('truckPlateNumber')"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-text-field
                              outlined
                              dense
                              v-model="formDoc.driver_mobile"
                              :label="$t('driverPhone')"
                              type="number"
                              prefix="+855"
                              :rules="phoneRulesOptional"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                          <v-autocomplete
                              v-model="formDoc.driver_province_code"
                              :items="provinceOptionList"
                              auto-select-first
                              item-text="text"
                              item-value="id"
                              :label="$t('millerLocation')"
                              outlined
                              dense
                          >
                            <template v-slot:selection="{ item }">{{ item.text }}</template>
                            <template v-slot:item="{ item }">{{ item.text }}</template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                    </fieldset>
                  </div>
                </v-row>
              </v-col>

              <v-col cols="12" sm="9" md="9">
                <v-row>
                  <v-col cols="5" sm="4" md="4">
                    <v-autocomplete
                        v-model="formDoc.category_id"
                        :items="categoryOptionList"
                        outlined
                        clearable
                        :dense="dense"
                        auto-select-first
                        item-text="text"
                        item-value="id"
                        :label="$t('category')"
                        :placeholder="$t('pleaseChooseCategory')"
                        :disabled="!! invoice_type"
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="7" sm="8" md="8">
                    <v-autocomplete
                        v-model="formDoc.product_id"
                        :items="productList"
                        outlined
                        :dense="dense"
                        item-text="name"
                        item-value="id"
                        clearable
                        :label="$t('product')"
                        :placeholder="$t('pleaseChooseProduct')"
                        :disabled="!! invoice_type"
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    <v-data-table
                        :headers="orderLineHeader"
                        :items="transaction_line"
                        hide-default-footer
                        mobile-breakpoint="0"
                    >
                      <template v-slot:header.product_name="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.qty="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.ab_fee="{ header }"><span v-if="invoice_type">{{ $t(header.text) }}</span>
                      </template>
                      <template v-slot:header.cost="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.total_cost="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.amount="{ header }">{{ $t(header.text) }}</template>
                      <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

                      <template v-slot:item.qty="{ item }">
                        <v-text-field
                            style="width: 150px"
                            type="number"
                            v-model="item.qty"
                            @change.native="updateTransactionOrderLine(item)"
                            @keyup.native="updateTransactionOrderLine(item)"
                            hide-details="auto"
                            :suffix="item.unit_name"
                            dense
                            min="1"
                        ></v-text-field>
                      </template>

                      <template v-slot:item.cost="{ item }">

                        <v-text-field
                            style="width: 150px"
                            type="number"
                            v-model="item.cost"
                            hide-details="auto"
                            :suffix="item.currency_symbol"
                            @change.native="updateTransactionOrderLine(item)"
                            @keyup.native="updateTransactionOrderLine(item)"
                            dense
                            min="1"
                            :readonly="!! invoice_type"
                        ></v-text-field>

                      </template>

                      <template v-slot:item.total_cost="{ item }">{{
                          item.total_cost | formatNumber
                        }}{{ item.currency_symbol }}
                      </template>

                      <template v-slot:item.ab_fee="{ item }">

                        <v-text-field
                            v-if="invoice_type"
                            style="width: 150px"
                            type="number"
                            v-model="item.ab_fee"
                            hide-details="auto"
                            :suffix="item.currency_symbol"
                            @change.native="updateTransactionOrderLine(item)"
                            @keyup.native="updateTransactionOrderLine(item)"
                            dense
                            min="1"
                        ></v-text-field>

                      </template>

                      <template v-slot:item.price="{ item }">

                        <v-text-field
                            style="width: 150px"
                            type="number"
                            v-model="item.price"
                            hide-details="auto"
                            :suffix="item.currency_symbol"
                            @change.native="updateTransactionOrderLine(item)"
                            @keyup.native="updateTransactionOrderLine(item)"
                            dense
                            min="1"
                            :readonly="!! invoice_type"
                        ></v-text-field>

                      </template>

                      <template v-slot:item.amount="{ item }">{{ item.amount | formatNumber }}{{
                          item.currency_symbol
                        }}
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            outlined
                            @click="handRemoveDetail(item)"
                            color="error"
                        >
                          <v-icon dark>
                            mdi-minus
                          </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-col>


                  <v-col cols="6" sm="6" md="6">
                    <v-textarea
                        clearable
                        v-model="formDoc.note"
                        clear-icon="mdi-close-circle"
                        rows="4"
                        outlined
                        :placeholder="$t('yourDesc')"
                        auto-grow
                        :label="$t('note')"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="6" md="6" sm="6" style="text-align: right"  v-if="invoice_type == 'final'">
                    <v-btn color="blue-grey" class="ma-2 white--text" @click="uploadFileModal = true">
                      {{$t("attachFile")}}
                      <v-icon right dark>mdi-cloud-upload</v-icon>
                      <span style="margin-left: 10px;" v-if="countImage"> ({{ countImage }})</span>
                    </v-btn>

                  </v-col>

                  <v-col cols="12" md="12" sm="12" xs="12">
                    <div cols="6" md="6" sm="6" xs="6">


                    <div style="float: left; width: 500px;">
                      <h3 style="text-align: right; height: 40px; line-height: 2.6; margin-right: 10px;">
                        {{ $t("totalCost") }} :</h3>
                    </div>
                    <div
                        style="width: calc(100% - 500px); line-height: 1.8; height: 40px; padding-left: 7px; background-color: lightgray;font-weight: bold;font-size: 25px; float: right">
                      {{ formDoc.total_cost | formatNumber }}{{ currency_symbol }}
                    </div>
                    <div style="clear:both"></div>
                    <br>

                    <div style="float: left; width: 500px;">
                      <h3 style="text-align: right; height: 40px; line-height: 2.6; margin-right: 10px;">
                        {{ $t("totalPrice") }} :</h3>
                    </div>
                    <div
                        style="width: calc(100% - 500px); line-height: 1.8; height: 40px; padding-left: 7px; background-color: lightgray;font-weight: bold;font-size: 25px; float: right">
                      {{ formDoc.total_amount | formatNumber }}{{ currency_symbol }}
                    </div>
                    <div style="clear:both"></div>
                    <br>

                    <div style="float: left; width: 500px;">
                      <h3 style="text-align: right; height: 40px; line-height: 2.6; margin-right: 10px;">
                        {{ $t("totalProfit") }} :</h3>
                    </div>
                    <div
                        style="width: calc(100% - 500px); line-height: 1.8; height: 40px; padding-left: 7px; background-color: lightgray;font-weight: bold;font-size: 25px; float: right">
                      {{ formDoc.total_profit | formatNumber }}{{ currency_symbol }}
                    </div>
                    </div>
                    <div style="clear:both"></div>
                  </v-col>


                  <!-- Final invoice -->
                  <v-col cols="6" md="6" sm="6" xs="6"></v-col>
                  <v-col v-if="invoice_type" cols="6" md="6" sm="6" xs="6">
                    <fieldset style="border:1px solid #9e9e9e; border-radius: 4px; padding: 15px;">
                      <legend style="margin-left: 10px; color: gray">{{ $t('paymentInformation') }}</legend>
                      <table style="width: 100%">
                        <tr style=" vertical-align: text-bottom;">
                          <td style="text-align: right"><label for="">{{ $t('receivePaymentDate') }}* : </label></td>
                          <td>
                            <v-menu
                                v-model="menuDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="payment_date"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                  :first-day-of-week="0"
                                  v-model="payment_date"
                                  @input="menuDate = false"
                              ></v-date-picker>
                            </v-menu>
                          </td>
                        </tr>

                        <tr style=" vertical-align: text-bottom;">
                          <td style="text-align: right"><label for="">{{ $t('fromAccount') }}* : </label></td>
                          <td>
                            <v-autocomplete
                                v-model="formDoc.ab_account_type"
                                :items="listAccountPayment"
                                auto-select-first
                                item-text="company_name"
                                item-value="account_type"
                                outlined
                                dense
                                :rules="selectRules"
                                required
                                :placeholder="$t('chooseAccount')"
                            >
                            </v-autocomplete>
                          </td>
                        </tr>

                        <tr style=" vertical-align: text-bottom;">
                          <td style="text-align: right"><label for="">{{ $t('balance') }}* : </label></td>
                          <td>
                            <v-text-field
                                outlined
                                dense
                                v-model="available_balance_format"
                                readonly
                                :suffix="getCurrencySymbol(formDoc.currency_code)"
                            ></v-text-field>
                          </td>
                        </tr>

                        <tr style=" vertical-align: text-bottom;">
                          <td style="text-align: right"><label for="">{{ $t('payToCropTrader') }}* : </label></td>
                          <td>
                            <v-autocomplete
                                v-model="formDoc.supplier_id"
                                :items="listCropTrader"
                                auto-select-first
                                item-text="full_name"
                                item-value="crop_id"
                                outlined
                                dense
                                :rules="selectRules"
                                required
                                readonly
                            >
                            </v-autocomplete>
                          </td>
                        </tr>

                        <tr style=" vertical-align: text-bottom;">
                          <td style="text-align: right"><label for="">{{ $t('totalPayment') }}* : </label></td>
                          <td>
                            <v-text-field
                                outlined
                                dense
                                v-model="total_cost_format"
                                readonly
                                :suffix="getCurrencySymbol(formDoc.currency_code)"
                            ></v-text-field>
                          </td>
                        </tr>
                      </table>
                    </fieldset>
                  </v-col>
                  <!-- End Final invoice -->


                  <v-col cols="12" sm="12" md="12">
                    <div style="float: right">
                      <v-btn v-if="invoice_type == ''" color="red darken-1" text @click="reset">Reset</v-btn>
                      <v-btn
                          v-if="invoice_type == ''"
                          class="mr-2"
                          rounded
                          @click="submit($event,true)"
                          style="min-width: 150px"
                          color="primary"
                      >
                        <font-awesome-icon
                            icon="check-circle"
                            style="margin-right: 10px"
                        />
                        {{ $t('saveAndPrint') }}
                      </v-btn>
                      <v-btn
                          rounded
                          @click="submit($event,false)"
                          style="min-width: 150px"
                          color="success"
                      >
                        <font-awesome-icon
                            icon="check-circle"
                            style="margin-right: 10px"
                        />
                        {{ $t('save') }}
                      </v-btn>
                    </div>
                  </v-col>

                </v-row>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </v-dialog>
    </v-form>
    <!-- End form section -->

    <!-- upload -->
    <v-dialog v-model="uploadFileModal" persistent max-width="600px">
      <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>

      <v-card>
        <v-card-title class="dialog-header">
          <span class="headline">{{ $t("attachFile") }}</span>
          <v-spacer></v-spacer>
          <v-btn
              fab
              text
              icon
              @click="uploadFileModal = false"
              valid="false"
              v-shortkey="['esc']"
              @shortkey.native="uploadFileModal = false"
          >
            <span class="white--text">
              <v-icon dark>
                mdi-close
              </v-icon>
            </span>
          </v-btn>

        </v-card-title>
        <v-card-text>

          <v-form>
            <v-container>
              <fieldset class="multiple-upload">
                      <span style="float:left" class="avatar-container" v-for="(pre, index) in previewImage" :key="index">
                        <img
                            v-show="['image/gif', 'image/png', 'image/jpg', 'image/jpeg'].includes(pre.type)"
                            :ref="'image'"
                            aspect-ratio="1"
                            class="grey lighten-2 multiple-preview"
                        >
                        <div v-if="['image/gif', 'image/png', 'image/jpg', 'image/jpeg'].includes(pre.type) == false" class="title-file">{{ pre.name }}</div>

                        <button type="button" class="remove-avatar" style="top: 2px; right: 8px" @click="removeFileUpload(index)">x</button>
                      </span>
                <div style="clear:both"></div>
              </fieldset>

              <label id="avatar" style="width: 130px">{{ $t("browFile") }}
                <input type="file" size="60"
                       multiple
                       @change="upload"
                >
              </label>

              <v-divider style="margin-top: 10px;"></v-divider>

              <div style="text-align:right">
                <v-btn class="v-btn v-btn--contained theme--light v-size--default error white--text" text @click="handleUpload(false)">
                  {{ $t('clear') }}
                </v-btn>

                <v-btn @click="handleUpload(true)" class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text>
                  <font-awesome-icon icon="check-circle" class="mr-1"/>
                  {{ $t('ok') }}
                </v-btn>
              </div>

            </v-container>
          </v-form>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainMixin from "../../../mixins/mainMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import moment from "moment";
import {provider} from "@/service/provider";
import axios from "axios";
import _ from "lodash";

export default {
  name: "buybackInvoiceDraft",
  mixins: [MainMixin, ValidatorMixin, OptionDataMixin],
  data() {
    return {
      total_amount: 0,
      total_amount_format: 0,
      total_cost: 0,
      total_cost_format: 0,
      total_profit: 0,
      total_profit_format: 0,
      available_balance_format: 0,
      invoice_type: '',
      listAccountPayment: [],
      payment_date: moment().format("YYYY-MM-DD"),
      previewImage  : [],
      storeImage  : [],
      countImage: 0,
      uploadFileModal: false,
      formDoc: {
        id: "",
        draft_invoice_id: "",
        client_id: "",
        supplier_id: "",
        currency_code: "",
        invoice_type: "",
        province_code: "",
        district_code: "",
        commune_code: "",
        loading_date: moment().format("YYYY-MM-DD"),
        unloading_date: moment().format("YYYY-MM-DD"),
        druck_plate_no: '',
        driver_mobile: '',
        driver_province_code: '',
        note: "",
        reference: "",
        total_amount: 0,
        total_cost: 0,
        total_profit: 0,
        paid_amount: 0,
        category_id: "",
        product_id: "",
        file: [],
        /**final account */
        ab_account_no: "",
        ab_account_type: "",
        available_balance: 0,
      },

      headers: [
        {text: "loading_date", align: "start", value: "loading_date", filterable: false},
        {text: "unloading_date", align: "start", value: "unloading_date", filterable: false},
        {text: "reference", value: "reference"},
        {text: "client", value: "client_name", sortable: false},
        {text: "supplier", value: 'supplier_name', sortable: false},
        {text: "quantity_in_kg", value: "total_quantity"},
        {text: "total_cost", value: "total_cost"},
        {text: "total_price", value: "total_sell"},
        {text: "total_margin", value: "total_margin"},
        {text: "action", align: "center", value: "action", sortable: false, width: 150}
      ],

      transaction_line: [],

      orderLineHeader: [
        {text: "productName", align: "start", sortable: false, value: "product_name"},
        {text: "qty", value: "qty", sortable: false},
        {text: "cost", value: "cost", sortable: false},
        {text: "totalCost", value: "total_cost", sortable: false},
        {text: "fee", value: "ab_fee", sortable: false},
        {text: "price", value: "price", sortable: false},
        {text: "totalPrice", value: "amount", sortable: false},
        {text: "action", value: "action", width: 50, sortable: false}
      ],

      currency_symbol: "",
    };
  },

  methods: {
    upload(event) {
      /** * splite extension to check validation */
      let selectedFiles  = event.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        this.previewImage.push(selectedFiles[i]);
      }

      this.renderImage();
      event.target.value = '';
    },

    removeFileUpload(index){
      this.previewImage.splice(index, 1);
      this.storeImage.splice(index, 1);
      this.renderImage();
    },

    renderImage() {
      let vm = this;
      for (let i = 0; i < vm.previewImage.length; i++) {
        let reader = new FileReader();

        if(['image/gif', 'image/png', 'image/jpg', 'image/jpeg'].includes(vm.previewImage[i].type)){
          reader.onload = () => {
            vm.$refs.image[i].src = reader.result;
            vm.storeImage[i] = reader.result;
          };
        }
        reader.readAsDataURL(vm.previewImage[i]);
      }
    },

    handleUpload(bool){
      if(bool){
        if(this.previewImage.length){
          this.countImage = this.previewImage.length;
          this.uploadFileModal = false;
        }else{
          this.$notify({
            title: "Error",
            message: this.$t("pleaseBroweImage"),
            type: "error",
            duration: 1200
          });
        }
      }else{
        this.previewImage = [];
        this.countImage   = 0;
        this.uploadFileModal = false;
      }
    },

    reset() {
      if (this.$refs.formData) {
        this.$refs.formData.reset();
        this.formDoc.loading_date = "";
        this.formDoc.driver_mobile = "";
        this.transaction_line = [];
        this.calculateTotal();
      }
    },

    handleAdd() {
      let vm = this;
      vm.reset();
      vm.dialog = true;
      vm.toggleAdd = true;
      vm.formDoc.id = "";
      vm.formDoc.client_id = "";
      vm.formDoc.supplier_id = '';
      vm.formDoc.driver_mobile = '';
      vm.formDoc.loading_date = moment().format("YYYY-MM-DD");
      vm.formDoc.unloading_date = moment().format("YYYY-MM-DD");
    },

    handleClose() {
      this.invoice_type = '';
      this.dialog = false;
      this.reset();
    },

    createFinalInvoice(id) {
      //console.log($router.name);
      this.invoice_type = 'final';
      this.handleAdd();
      this.$nextTick(() => {
        let url = provider.baseURL + provider.fetchListDraftInvoice;

        let params = {
          search: "",
          id: id,
          contact_id: "",
          type_order: "",
          offset: 0,
          limit: 1,
          sort_by: "created_at",
          sort_desc: 1,
          from_date: "",
          to_date: "",
        };
        axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(res => {
          if (res.data.response && res.data.response.code === 200) {
            let data = res.data.data[0];

            this.formDoc.id = data.id;
            this.formDoc.draft_invoice_id = data.id;
            this.formDoc.client_id = data.client_id;
            this.formDoc.supplier_id = data.supplier_id;
            this.formDoc.currency_code = data.currency_code;
            this.formDoc.province_code = data.province_code;
            this.formDoc.province_code = data.province_code;
            this.formDoc.district_code = data.district_code;
            this.formDoc.commune_code = data.commune_code;
            this.formDoc.loading_date = moment(data.loading_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
            this.formDoc.unloading_date = moment(data.accepted_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
            this.formDoc.druck_plate_no = data.druck_plate_no;
            this.formDoc.driver_mobile = data.driver_mobile;
            this.formDoc.driver_province_code = data.driver_province_code;
            this.formDoc.note = data.note;
            this.formDoc.total_amount = data.total_amount;
            this.transaction_line = data.transaction_line;
            this.payment_date = moment().format("YYYY-MM-DD");

            this.transaction_line.forEach((arr, index) => {
              this.transaction_line[index].draft_invoice_line_id = arr.transaction_line_id;
              this.transaction_line[index].cost = arr.cost;
              this.transaction_line[index].price = arr.price;
              this.transaction_line[index].price_old = arr.price;
              this.transaction_line[index].ab_fee = 0;
            });

            this.fetchWalletAccount();
          }
        }).catch(error => console.log(error));


      });
    },

    fetchWalletAccount() {
      let url = provider.baseURL + provider.fetchWalletAccount;

      let params = {
        // account_no : "0965529588",
        currency_code: this.formDoc.currency_code
      };

      axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(res => {
        if (res.data.response && res.data.response.code === 200) {
          this.listAccountPayment = res.data.data;
        }
      }).catch(error => console.log(error));

    },

    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchListDraftInvoice({
        contact_id: "",
        type_order: "",
        search: vm.search,
        id: "",
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        status: '',
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0] === false ? 0 : 1,
        from_date: vm.from_date,
        to_date: vm.to_date,
      })
    }, 350),

    handleRemove(removeId) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + removeId + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        vm.overlay = true;
        let url = provider.baseURL + provider.destroyCropTransaction;
        axios.post(url, {id: removeId}, {headers: {Authorization: localStorage.token}}).then(res => {
          if (res.data.response.code === 200) {
            vm.$notify({
              title: "Success",
              message: vm.$t('success'),
              type: "success",
              duration: 2000
            });
          }
          vm.fetchDataTable();
          vm.overlay = false;
        });

      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },

    handleEdit(item, event) {
      event.preventDefault();
      let vm = this;
      vm.formDoc = {};
      vm.overlay = true;
      vm.toggleAdd = false;

      let url = provider.baseURL + provider.fetchListDraftInvoice;

      let params = {
        search: "",
        id: item.id,
        contact_id: "",
        type_order: "",
        offset: 0,
        limit: 1,
        sort_by: "created_at",
        sort_desc: 1,
        from_date: "",
        to_date: "",
      };

      return new Promise((resolve, reject) => {
        axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                vm.overlay = false;
                vm.dialog = true;
                resolve(res.data.data);
                let newItem = res.data.data[0];

                vm.formDoc = newItem;
                vm.formDoc.reference = newItem.reference.replace("INV", "");
                vm.formDoc.category_id = "";
                vm.formDoc.product_id = "";
                vm.formDoc.file = [];
                vm.formDoc = Object.assign({}, newItem);

                vm.formDoc.total_amount = parseFloat(vm.formDoc.total_amount);
                vm.formDoc.loading_date = moment(vm.formDoc.loading_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                vm.formDoc.unloading_date = moment(vm.formDoc.accepted_date, 'DD-MM-YYYY').format("YYYY-MM-DD");
                vm.transaction_line = [];
                vm.transaction_line.push(...newItem.transaction_line);

                vm.transaction_line.map((d) => {
                  d.currency_code = vm.formDoc.currency_code;
                  d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                  d.qty = parseFloat(d.qty);
                  d.quality = parseFloat(d.quality);
                  d.cost = parseFloat(d.cost);
                  d.price = parseFloat(d.price);
                  d.amount = parseFloat(d.amount);
                  return d;
                })
              }
            },
            error => {
              reject(error);
            }
        );
      });


    },

    submit(e, isPrint) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formData.validate()) {
        if (vm.transaction_line.filter(obj => {
          return obj.qty > 0
        }).length) {

          if (this.invoice_type) {
            if (this.formDoc.available_balance < this.formDoc.total_amount) {
              vm.$notify({
                title: "Error",
                message: vm.$t("walletNotEnough"),
                type: "error",
                duration: 2000
              });
              return true;
            }
          }

          vm.overlay = true;
          vm.formDoc.user_id = localStorage.id;
          vm.transaction_line.map((d) => {
            d.quality = parseFloat(d.quality);
            d.qty = parseFloat(d.qty);
            d.price = parseFloat(d.price);
            d.cost = parseFloat(d.cost);
            d.amount = parseFloat(d.amount);
            return d;
          })
          vm.formDoc.note = vm.formDoc.note || "";
          vm.formDoc.transaction_line = vm.transaction_line;
          let newFormDoc = Object.assign({}, vm.formDoc);
          newFormDoc.loading_date = vm.parseToDate(vm.formDoc.loading_date);
          newFormDoc.unloading_date = vm.parseToDate(vm.formDoc.unloading_date);
          if (this.invoice_type) {
            newFormDoc.date = vm.parseToDate(vm.payment_date);
          }
          newFormDoc.total_amount = vm.total_amount;
          if (vm.storeImage.length) {
            for( var i = 0; i < this.storeImage.length; i++ ){
              newFormDoc.file.push(this.storeImage[i]);
            }
          }
          let url = this.invoice_type ? provider.storeFinalInvoice : provider.storeDraftInvoice;
          url = provider.baseURL + url;

          return new Promise((resolve, reject) => {
            axios.post(url, newFormDoc, {headers: {
                Authorization: localStorage.token //,"Content-Type": "multipart/form-data"
                }}).then(
                res => {
                  if (res.data.response && res.data.response.code === 200) {
                    resolve(res.data.data.transaction_invoice_id);
                    this.previewImage = [];
                    this.countImage   = 0;
                    vm.$notify({
                      title: "Success",
                      message: vm.$t("success"),
                      type: "success",
                      duration: 700
                    });
                    vm.dialog = false;
                    if (isPrint === true && res.data.data.transaction_invoice_id) {
                      vm.$router.push({
                        name: 'beeshop.buyback.buyback-trading.invoice-draft-print',
                        params: {id: res.data.data.transaction_invoice_id}
                      })
                    }
                    vm.fetchDataTable();
                    vm.overlay = false;

                  }
                },
                error => {
                  reject(error);
                }
            );
          });
        } else {
          vm.$notify({
            title: "Error",
            message: vm.$t("pleaseCheckProductOrder"),
            type: "error",
            duration: 2000
          });
        }
      }
    },

    handRemoveDetail(item) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + item.name + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        vm.removeTransactionOrderLine(item);
        vm.$message({
          type: 'success',
          message: vm.$t('deleteComplete')
        });
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },

    removeTransactionOrder(id) {
      let vm = this;
      let url = provider.baseURL + provider.removeTransactionOrder;
      return new Promise((resolve, reject) => {
        axios.post(url, {id: id}, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                vm.$message({
                  type: 'success',
                  message: vm.$t('deleteComplete')
                });
                vm.fetchDataTable();
              }
            },
            error => {
              reject(error);
            }
        );
      });
    },

    removeTransactionOrderLine(row) {
      let vm = this;
      let index = vm.transaction_line.findIndex(
          ind => ind.product_id === row.product_id
      );
      vm.transaction_line.splice(index, 1);
      vm.calculateTotal();

    },

    updateTransactionOrderLine(row) {
      //When we update order line by change qty
      let vm = this;
      let newDoc = row;
      let index = vm.transaction_line.findIndex(ind => ind.product_id == row.product_id);
      newDoc.transaction_line_id;
      newDoc.qty = parseFloat(newDoc.qty);
      newDoc.quality = parseFloat(newDoc.quality);
      newDoc.cost = vm.convertExchangeRate(row.currency_code, vm.formDoc.currency_code, parseFloat(row.cost || 0));
      newDoc.price = vm.convertExchangeRate(row.currency_code, vm.formDoc.currency_code, parseFloat(row.price || 0));

      /** Finala invoice */
      if (this.invoice_type) {
        if (+newDoc.ab_fee) {
          newDoc.price = +newDoc.price + +newDoc.ab_fee;
        } else {
          newDoc.price = +newDoc.price_old;
        }
      }

      newDoc.currency_code = vm.formDoc.currency_code;
      newDoc.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
      newDoc.amount = newDoc.qty * parseFloat(newDoc.price);
      newDoc.total_cost = newDoc.qty * parseFloat(newDoc.cost);
      newDoc.product_description = '';
      vm.transaction_line[index] = newDoc;

      vm.$nextTick(() => {
        vm.calculateTotal();
        vm.formDoc.product_id = "";
      });
    },

    addToTransactionOrderLine(val) {
      let vm = this;
      if (val) {
        let productDoc = vm.productList.find(obj => obj.id === val);
        if (productDoc) {
          let price = 0;
          let cost = 0;
          cost = vm.convertExchangeRate(productDoc.currency_code, vm.formDoc.currency_code, parseFloat(productDoc.cost || 0));
          price = vm.convertExchangeRate(productDoc.currency_code, vm.formDoc.currency_code, parseFloat(productDoc.price || 0));
          //Check product already choose
          let checkExist = vm.transaction_line.find(od => od.product_id === val);
          if (checkExist) {
            //Update product to increase qty
            checkExist.qty = parseFloat(checkExist.qty) + 1;
            vm.updateTransactionOrderLine(checkExist);
          } else {
            //Add new product to order
            if (productDoc) {
              vm.transaction_line.push({
                transaction_line_id: "",
                product_id: productDoc.id,
                variation_id: productDoc.variation_id,
                product_name: productDoc.variation_name,
                qty: 1,
                quality: 0,
                currency_code: vm.formDoc.currency_code,
                currency_symbol: vm.getCurrencySymbol(vm.formDoc.currency_code),
                unit_name: productDoc.unit_name,
                unit_id: parseInt(productDoc.unit_id),
                cost: cost,
                total_cost: cost,
                price: price,
                amount: price,
                product_description: ""
              });
              vm.$notify({
                title: "Success",
                message: vm.$t("addProductSuccess"),
                type: "success",
                duration: 700
              });
            } else {
              vm.$notify({
                title: "Error",
                message: vm.$t("canNotFind"),
                type: "error",
                duration: 700
              });
            }
            vm.$nextTick(() => {
              vm.calculateTotal();
              vm.formDoc.product_id = "";
            });
          }
        }

      }
    },

    calculateTotal() {
      let vm = this;
      vm.formDoc.total_amount = 0;
      vm.formDoc.total_cost = 0;
      vm.formDoc.total_profit = 0;
      vm.transaction_line.forEach((obj) => {
        vm.formDoc.total_amount += parseFloat(obj.amount);
        vm.formDoc.total_cost += parseFloat(obj.total_cost);
      });

      vm.total_amount = vm.formDoc.total_amount;
      vm.total_cost = vm.formDoc.total_cost;
      vm.total_profit = vm.formDoc.total_amount - vm.formDoc.total_cost;
      vm.formDoc.total_profit = vm.total_profit;
    },

    handleFetchProduct() {
      let vm = this;
      if (vm.formDoc.currency_code && this.formDoc.category_id && this.formDoc.client_id) {
        vm.fetchProduct('', this.formDoc.category_id, this.formDoc.client_id, vm.formDoc.currency_code, 'paddy', 'miller');
      }
    },

    handlePayment(transaction_id, client_id) {
      this.$store.dispatch('updateBuybackDialogPayment', {
        dialog: true,
        transaction_id: transaction_id,
        client_id: client_id
      });
    },

    handleSearch() {
      this.fetchDataTable();
    }

  },
  computed: {
    /** base on transaction line */
    enabledUser() {
      if (this.transaction_line.length) {
        return true;
      }
      return false;
    },

  },
  watch: {
    "formDoc.client_id"() {
      this.categoryOptionList = [];
      this.productList = [];
      this.fetchCategoryOption(this.formDoc.client_id, '', ['paddy']); //here params supplier_id instead as client_id cos all every things of api has set name supplier_id
      this.handleFetchProduct();
    },
    "formDoc.category_id"() {
      this.handleFetchProduct();
    },

    "formDoc.product_id"(val) {
      if (val) {
        this.addToTransactionOrderLine(val);
      }
    },

    "formDoc.currency_code"(val) {
      if (val) {
        let vm = this;
        vm.transaction_line.forEach((d) => {
          vm.updateTransactionOrderLine(d);
        });
        vm.currency_symbol = vm.getCurrencySymbol(val);
        vm.fetchCategoryOption(this.formDoc.client_id, '', ['paddy']); //here params supplier_id instead as client_id cos all every things of api has set name supplier_id
        vm.handleFetchProduct();
      }
    },

    "formDoc.province_code"(val) {
      if (val) {
        let vm = this;
        vm.getDistrict(val);
      }
    },
    "formDoc.district_code"(val) {
      if (val) {
        let vm = this;
        vm.getCommune(val);
      }
    },
    "formDoc.commune_code"(val) {
      if (val) {
        let vm = this;
        vm.getVillage(val);
      }
    },

    "formDoc.ab_account_type"(val) {
      let account_payment = this.listAccountPayment.filter(obj => {
        return obj.account_type == val;
      });

      if (account_payment.length) {
        account_payment = account_payment[0];
        this.formDoc.available_balance = account_payment.available_balance;
        this.formDoc.ab_account_no = account_payment.account_no;
        this.formDoc.account_no = account_payment.account_no;
      }
    },

    "formDoc.total_amount"(val) {
      this.total_amount_format = this.formatNumber(val)
    },
    "formDoc.total_cost"(val) {
      this.total_cost_format = this.formatNumber(val)
    },
    "formDoc.total_profit"(val) {
      this.total_profit_format = this.formatNumber(val)
    },
    "formDoc.available_balance"(val) {
      this.available_balance_format = this.formatNumber(+val)
    },

    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },

    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },

    dialog(val) {
      if (val === false) {
        this.reset();
      } else {
        if (this.isMiller || this.isExporter) {
          this.formDoc.client_id = this.$store.state.userDoc.contact_id;
        }
        if (this.isOperator) {
          this.fetchListMillerAndExporter();
          // this.fetchListMiller();
        }
        this.fetchListCropTrader();
        this.fetchCurrencyOption();
        this.fetchListInvoiceType(this.invoice_type);
        this.getProvince();
      }
    },
  }
};
</script>


<style scoped>
#avatar{
  text-align: center;
  width: 100%;
  padding: 10px;
  background: gray;
  display: table;
  color: #fff;
  cursor: pointer;
  margin:0;
  margin-top:10px;
}
input[type="file"] {
  display: none;
}

.avatar-container {
  position: relative;
}

.avatar-container .remove-avatar {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #ffffff;
  background-color: #b3b3b3;
  border-radius: 50%;
  width: 24px;
  height: 25px;
  line-height: 1.5;
}

.v-btn--floating .v-btn__content {
  height: auto !important;
}

.dimention {
  justify-content: center;
  display: flex;
}

.multiple-upload {
  min-height: 115px;
  border: 1.5px solid gray;
  border-style: dotted;
  padding-left: 5px;
  font-size: 16px;
}

.title-file {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  line-height: 5;
}

.multiple-preview, .title-file {
  width: 100px;
  height: 80px;
  margin-right: 5px;
  margin-bottom: 5px;
  border: 1px solid gray;
}

</style>